export default {
  title: {
    en: 'YOUR SUBSCRIPTION IS PAUSED',
  },
  text: {
    en: `
      <p>
        We’ll miss you while you’re away, but in the mean time, you can still check out new fragrances, 
        and even add them to your queue for&nbsp;the&nbsp;future.
      </p>
      <p>
        You won't be charged until you reactivate your account.
      </p>
    `,
  },
  buttonOk: {
    en: 'Ok, I understand',
  },
  didNotMean: {
    en: 'Didn’t mean to pause?',
  },
  reactivate: {
    en: 'Reactivate my account, please!',
  },
}
